import React from 'react'
import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@hub/accordion'
import { Text } from '@hub/text'
import { Link } from '@hub/link'
import { Stack } from '@hub/stack'
import { Item } from '../types'
import analyticsUtils from '../../../helpers/analytics-utils'
import trackEvent from '../../../helpers/analytics-utils/track-event'

interface PaneAccordionProps {
  itemCnt: number
  itemTitle: string
  items: Item[]
}

export const PaneAccordion: React.FC<PaneAccordionProps> = ({
  itemCnt,
  itemTitle,
  items,
}) => (
  <AccordionItem
    sx={{
      border: 'none',
      paddingTop: 'spacing-sm',
      paddingBottom: 'spacing-md',
      width: 'size-full',
    }}
  >
    <AccordionButton sx={{ padding: 0, margin: 0 }}>
      <Text tone="strong" fontSize="font-lg" align="left" sx={{ flex: 1 }}>
        {itemTitle}
      </Text>
      <AccordionIcon />
    </AccordionButton>
    <AccordionPanel>
      <Stack
        gap="spacing-lg"
        sx={{
          paddingX: 'spacing-md',
          paddingTop: 'spacing-lg',
          fontSize: 'font-sm',
          lineHeight: '16px',
        }}
      >
        {items &&
          items.map((item, i) => {
            if (!item || !('url' in item)) {
              return null
            }
            return (
              <Link
                to={item.url}
                href={item.url}
                key={i}
                onClick={() => {
                  trackEvent(
                    analyticsUtils.categories.UNIVERSAL_HEADER,
                    analyticsUtils.actions.UNIVERSAL_HEADER_NAV_LINK_CLICK,
                    `L1-${itemCnt}-${i} ${itemTitle} - ${item.label}`
                  )
                  item.onClick?.()
                }}
              >
                {item.label}
              </Link>
            )
          })}
      </Stack>
    </AccordionPanel>
  </AccordionItem>
)
